import iconVerified from "../../../Icons/icons-white/verified.png";
import iconVerifiedNeeded from "../../../Icons/icons-white/verification-needed.png";
import iconBackStep from "../../../Icons/icons-black/back.png";
import iconListings from "../../../Icons/icons-black/listings.png";
import iconB3B3B3 from "../../../Icons/icons-gray/B3B3B3.png";
import iconCamara from "../../../Icons/icons-white/camara.png";
import iconViews from "../../../Icons/icons-charcoal-dark/views.png";
import iconCall from "../../../Icons/icons-white/call.png";
import iconGo from "../../../Icons/icons-white/go.png";
import iconBack from "../../../Icons/icons-white/back.png";
import iconBlackAdd from "../../../Icons/icons-black/add.png";
import iconWhiteForward from "../../../Icons/icons-white/forward.png";
import iconWeb from "../../../Icons/icons-white/web.png";
import iconBackArrow from "../../../Icons/icons-white/back-arrow.png";

import iconYellowWhatsApp from "../../../Icons/NV/yellow/whatsApp.png";
import iconYellowLocation from "../../../Icons/NV/yellow/location.png";
import iconYellowCall from "../../../Icons/NV/yellow/call.png";
import iconYellowEmail from "../../../Icons/NV/yellow/mail.png";
import iconYellowWebsite from "../../../Icons/NV/yellow/web.png";

import iconBlackWhatsApp from "../../../Icons/icons-black/whatsApp.png";
import iconBlackLocation from "../../../Icons/icons-black/location.png";
import iconBlackCall from "../../../Icons/icons-black/call.png";
import iconBlackEmail from "../../../Icons/icons-black/mail.png";
import iconBlackWebsite from "../../../Icons/icons-black/website.png";

import iconStar from "../../../Icons/icons-yellow/star.png";
import iconWhiteViews from "../../../Icons/icons-white/views.png";
import iconWhiteLikes from "../../../Icons/icons-white/like.png";
import iconWhiteExit from "../../../Icons/icons-white/exit.png";
import iconWhiteListed from "../../../Icons/icons-white/listed.png";
import iconCharcoalDarkSave from "../../../Icons/icons-charcoal-dark/save.png";
import iconCharcoalDarkSaved from "../../../Icons/icons-charcoal-dark/saved.png";
import iconCharcoalDarkShare from "../../../Icons/icons-charcoal-dark/share.png";
import iconCharcoalNotify from "../../../Icons/icons-charcoal-dark/notify.png";
import iconWhiteNotify from "../../../Icons/icons-white/notify.png";
import iconCharcoalNotNotify from "../../../Icons/icons-charcoal-dark/not-notify.png";
import iconDarkSearch from "../../../Icons/icons-charcoal-dark/search.png";
import iconDarkExit from "../../../Icons/icons-charcoal-dark/exit.png";

import iconSMWhatsApp from "../../../Icons/icons-SM/whatsapp.png";
import iconSMMAIVerified from "../../../Icons/icons-SM/MAI-VERIFIED.png";
import iconSMCall from "../../../Icons/icons-SM/call.png";

import iconBlackViews from "../../../Icons/icons-black/views.png";
import iconBlackShare from "../../../Icons/icons-black/share.png";
import iconBlackSave from "../../../Icons/icons-black/save.png";
import iconBlackSaved from "../../../Icons/icons-black/saved.png";
import iconBlackMoreMenu from "../../../Icons/icons-black/more-menu.png";
import iconBlackInfo from "../../../Icons/icons-black/info.png";
import iconBlackFilter from "../../../Icons/icons-black/filter.png";

import iconWhiteCall from "../../../Icons/NV/white/call.png";
import iconWhiteWhatsApp from "../../../Icons/NV/white/whatsApp.png";
import iconYellowSaved from "../../../Icons/NV/yellow/saved.png";
import iconYellowSave from "../../../Icons/NV/yellow/save.png";
import iconYellowShare from "../../../Icons/NV/yellow/share.png";
import iconYellowDotsMenu from "../../../Icons/NV/yellow/dots menu.png";
import iconYellowInfo from "../../../Icons/NV/yellow/info.png";
import iconWhiteShare from "../../../Icons/NV/white/share.png";
import iconWhiteView from "../../../Icons/NV/white/view.png";
import iconWhiteAdd from "../../../Icons/NV/white/add.png";

import iconYellowEdit from "../../../Icons/NV/yellow/edit.png";
import iconRedDelete from "../../../Icons/NV/red/delete.png";

import GENRALHELPERS from "../GENRAL-HELPERS";
import handleAccount from "../register/handle-account";
import firebase from "../firebase";

class GenerateHtml {
  _generateBusinessRewiewStars(number, numberOfRewviews) {
    // TODO need to develop a rating system
    return ``;
    let starHtml = ``;
    const stars = Math.round(number);
    if (stars === 0) {
      starHtml += `<img style="height: 10px;" src="${iconStar}" alt="">`;
    } else {
      for (let i = 0; i < stars; i++) {
        starHtml += `<img style="height: 10px;" src="${iconStar}" alt="">`;
      }
    }
    // <div class="RatingStarReviewText">
    //   ${reviews} calificaciones
    // </div>
    return `<div class="RatingStarCon1">
        <div class="RatingStarCon2">
          <div class="RatingStarRatedAtNumber">
            ${number}
          </div>
          <div class="RatingStarCon3">
            ${starHtml}
          </div>
          <div class="RatingStarReviewText">
            ${numberOfRewviews} calificaciones
          </div>
        </div>
    
      </div>`;
  }






  _generateBusiness(data, id) {
    let businessCategoriesHTML = ``;
    const account = firebase._getLatestCurrentUserData();
    console.log(data);

    if (!data) return


    let editButtonDisplay = 'none'

    if (account?.businesses?.some(b => b.id === data?.businessId)) {
      editButtonDisplay = 'flex';
    }

    function pluralizeEs(word) {
      if (!word) return word;

      const STOP_WORDS = new Set([
        'de', 'del', 'con', 'a', 'al', 'en', 'por', 'para', 'sin', 'y', 'o', 'rtk'
      ]);

      const capitalize = str =>
        str.charAt(0).toUpperCase() + str.slice(1);

      // handle hyphenated words (pluralize each meaningful part)
      if (word.includes('-')) {
        return word
          .split('-')
          .map(part => {
            const lower = part.toLowerCase();

            // stop words stay lowercase
            if (STOP_WORDS.has(lower)) return lower;

            const plural = pluralizeEs(part);
            return capitalize(plural);
          })
          .join(' ');
      }

      let result;

      // already plural-ish
      if (word.endsWith('s') || word.endsWith('es')) {
        result = word;
      }
      // z → ces
      else if (word.endsWith('z')) {
        result = word.slice(0, -1) + 'ces';
      }
      // vowel → s
      else if (/[aeiouáéíóú]$/i.test(word)) {
        result = word + 's';
      }
      // consonant → es
      else {
        result = word + 'es';
      }

      // capitalize single words (unless stop word)
      return STOP_WORDS.has(result.toLowerCase())
        ? result.toLowerCase()
        : capitalize(result);
    }


    const generatBusinessCategories = () => {
      console.warn(data.categories)
      function sortByMachineAlphabetically(data) {
        return [...data].sort((a, b) =>
          a.machine.localeCompare(b.machine, "es", { sensitivity: "base" })
        );
      }

      if (data.categories) {
        sortByMachineAlphabetically(data.categories).forEach((cat) => {
          let tagName = pluralizeEs(cat.machine)
          if (cat.name) {
            tagName = cat.name
          }
          if (cat)
            businessCategoriesHTML += `
          <div data-machine="${cat.machine}" class="nvBusinessEachCon21">
            <div class="nvBusinessEachCon21BC">
              ${cat?.image?.res_200?.length
                ? `<img class="nvBusinessEachCon21Img" src="${cat.image.res_200}" />`
                : ''
              }
            </div>
            <div class="nvBusinessEachCon21B">
              <div class="nvBusinessEachText8">${tagName}</div>
              <div class="nvBusinessEachText9">${cat?.number ?? 0}</div>
            </div>
          </div>
      `;
        });
      }
    };
    generatBusinessCategories();

    let SavedHtml = `
            <div id="btnActionBusinessSave" class="nvBusinessOptionsEachCon14" style="display: none;">
              <img height="12" src="${iconBlackSave}"/>
              <div class="nvBusinessOptionsEachText14">Guardar</div>
            </div>
          `;



    const checkIfSaved = (path) => {
      let saved = false;

      if (account && account.activeSaves) {
        if (account.activeSaves.includes(path)) {
          saved = true;
        }
      }

      if (saved) {
        SavedHtml = `
            <div id="btnActionBusinessSave" class="nvBusinessOptionsEachCon14" style="display: none;">
              <img height="12" src="${iconBlackSaved}"/>
              <div class="nvBusinessOptionsEachText14">Quitar Guardado</div>
            </div>
          `;
      }
    };
    console.log(account);
    console.log(data.businessId);
    if (account) {
      checkIfSaved(`businesses/${data.businessId}`);
    }

    let profUrl = data.profileImg
    let backUrl = data.backgroundImg


    if (data.images) {
      profUrl = data.images.profile[0].res_200
      backUrl = data.images.background[0].res_500
    }

    return `
<div
  data-is="business"
  data-businessid="${data.businessId}"
  class="bussinessDisplayCon1 ActionForShare">

  <div id="nvBusinessEachCon1A" class="nvBusinessEachCon1A">
    <div id="nvBusinessEachCon1B" class="BnvBusinessEachCon1B">



          <div class="BnvBusinessEachCon2 CloseCurrentStackPageButton">
            <div id="BnvBusinessEachCon3" class="BnvBusinessEachCon3">
              <img height="20px" src="${iconBack}"/>
            </div>
          </div>


      <div class="BnvBusinessEachCon7B">
        <div class="nvBusinessEachConBackCon"></div>
        <img src="${backUrl}" class="nvBusinessEachConBackIMG">
        <div class="BnvBusinessEachCon6C">






          <div class="BnvBusinessEachCon22">
            <div class="BnvImgDisplayerListingEachCon9">
              <div class="nvImgDisplayerListingEachCon10">
                <div class="nvImgDisplayerListingEachCon11">
                  <div class="nvImgDisplayerListingEachText1">${GENRALHELPERS._formatNumberShort(data.views)}</div>
                  <img height="6px" src="${iconWhiteView}"/>
                </div>
                <div class="nvImgDisplayerListingEachCon11">
                  <div class="nvImgDisplayerListingEachText1">${GENRALHELPERS._formatNumberShort(data.shares)}</div>
                  <img height="6px" src="${iconWhiteShare}"/>
                </div>
              </div>
              <div class="BnvImgDisplayerListingEachText2">desde, ${GENRALHELPERS._convertServerTimestampToReadableTime(data.createdAt, false)}</div>
            </div>
          </div>
        </div>

        <div class="BnvBusinessEachCon6B">
          <div class="BnvBusinessEachCon6">
            <div class="BnvBusinessEachText2">${data.name}</div>
            <div class="BnvBusinessEachText3">${data.shortDescription}</div>
          </div>

          <div class="BnvBusinessEachConProfileIMGCon">
            <img src="${profUrl}" class="nvBusinessEachConProfileIMG ImgForBigDisplay">
          </div>

          <div class="BnvBusinessEachCon6D1">
            <div id="btnActionBusinessContactShowOptions" class="BnvBusinessEachCon6D2">
              <div class="BnvBusinessEachCon6DText1">Contacto</div>
              <img height="12px" src="${iconWhiteForward}"/>
            </div>
            <div id="btnActionBusinessOptionsShowOptions" class="BnvBusinessEachCon6D3">
              <div class="BnvBusinessEachCon6DText2">Mas</div>
              <img height="12px" src="${iconWhiteAdd}"/>
            </div>
          </div>
        </div>
      </div>

    </div> 


    <div id="bussinessDisplayHeaderCon1A" class="nvBusinessEachCon20A"></div>
    <div id="nvBusinessEachCon20AB" class="nvBusinessEachCon20AB">
      <div class="nvBusinessEachCon20AC">
        <img src="${iconBlackFilter}" height="10px" />
      </div>
      <div id="bussinessDisplayHeaderCon1" class="nvBusinessEachCon20">
        <div id="categorySelectMainConInBusiness" class="nvBusinessEachCon20B">
          <div data-machine="all" class="nvBusinessEachCon21 nvBusinessEachCon21Act">
            <div class="nvBusinessEachCon21BC">

              <img class="nvBusinessEachCon21Img" src="${profUrl}" />

            </div>
            <div class="nvBusinessEachCon21B">
              <div class="nvBusinessEachText8">Todos</div>
              <div class="nvBusinessEachText9">${data?.numberOfListings ?? 0}</div>
            </div>
            <div class="categorySelectMiniCon3"></div>
          </div>      
          ${businessCategoriesHTML}
        </div>
      </div>
    </div>

    <div id="bussinessDisplayInsertListingsCon" class="nvBusinessEachCon19"></div>
  </div>



  <div id="nvBusinessContactEachCon12A" class="nvBusinessContactEachCon12A topRightExitButtonOnFullScreenOverlay" style="display: flex;">
    <div id="nvBusinessContactEachCon12" class="nvBusinessContactEachCon12 nvBusinessContactEachCon12View" style="display: flex;">

      <div class="nvBusinessContactEachCon12B">
        <div class="nvBusinessContactEachCon12C">
        </div>
      </div>

      <div class="nvBusinessContactEachCon13C">
        <div class="nvBusinessContactEachCon13">
          <div class="nvBusinessContactEachText10">Ponte en contacto con nosotros</div>
          <div class="nvBusinessContactEachCon13B" style="display: none;">
            <div class="nvBusinessContactEachText10B">@bernardoklassen</div>
          </div>
        </div>
        <div class="nvBusinessContactEachCon14">
          <div id="btnActionBusinessContactWhatsApp" class="nvBusinessContactEachCon15">
            <div class="nvBusinessContactEachText11">WhatsApp</div>
            <img height=24px" src="${iconWhiteWhatsApp}"/>
          </div>
          <a id="btnActionBusinessContactCall" 
            class="nvBusinessContactEachCon16" 
            href="tel:+52${data.contacts.call.contact}">
            <div class="nvBusinessContactEachText12">Llamar</div>
            <img src="${iconWhiteCall}" height="24px" />
          </a>

          <!-- Email button can be added. 'nvBusinessContactEachCon16B' is the button class -->

        </div>
      </div>
      <div class="nvBusinessContactEachCon17">
        <div class="nvBusinessContactEachText13">Siempre listos</div>
        <div class="nvBusinessContactEachText14">para resolver tus dudas</div>
      </div>
    </div>
  </div>



  <div id="nvBusinessOptionsEachCon12A" class="nvBusinessOptionsEachCon12A topRightExitButtonOnFullScreenOverlay" style="display: flex;">
    <div class="nvBusinessOptionsEachCon12">
      <div class="nvBusinessOptionsEachCon13">
        <div class="nvBusinessOptionsEachCon13B">
          <div id="btnActionBusinessInfo"  class="nvBusinessOptionsEachCon14">
            <img src="${iconBlackInfo}" height="12px" />
            <div class="nvBusinessOptionsEachText14">Info</div>
          </div>

          ${SavedHtml}
          
          <div id="btnActionBusinessShare" class="nvBusinessOptionsEachCon14">
            <img height="16" src="${iconBlackShare}"/>
            <div class="nvBusinessOptionsEachText14">Compartir</div>
          </div>
        </div>

        <div class="nvBusinessOptionsEachCon13B" style="display: ${editButtonDisplay}">
          <div id="btnActionBusinessEdit" class="nvBusinessOptionsEachCon14" style="display: ${editButtonDisplay}">
            <img height="10px" src="${iconYellowEdit}"/>
            <div class="nvBusinessOptionsEachText15">Editar negocio</div>
          </div>

          <div id="btnActionBusinessDelete" class="nvBusinessOptionsEachCon14" style="display: ${editButtonDisplay}">
            <img height="10px" src="${iconRedDelete}"/>
            <div class="nvBusinessOptionsEachText15B">Eliminar negocio</div>
          </div>
        </div>
      </div>
    </div>
  </div>




  <div id="nvBusinessEachListsOptionsCon12A" class="nvBusinessOptionsEachCon12A topRightExitButtonOnFullScreenOverlay" style="display: flex;">
    <div class="nvBusinessOptionsEachCon12">
      <div class="nvBusinessOptionsEachCon13">
        <div class="nvBusinessOptionsEachCon13B">
          <div id="btnActionBusinessListShare" class="nvBusinessOptionsEachCon14">
            <img height="16" src="${iconBlackShare}"/>
            <div class="nvBusinessOptionsEachText14">Compartir Lista</div>
          </div>
        </div>

        <div class="nvBusinessOptionsEachCon13B" style="display: ${editButtonDisplay}">
          <div id="btnActionBusinessListEdit" class="nvBusinessOptionsEachCon14" style="display: ${editButtonDisplay}">
            <img height="10px" src="${iconYellowEdit}"/>
            <div class="nvBusinessOptionsEachText15">Editar Lista</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="nvBusinessInfoEachCon12A" class="nvBusinessInfoEachCon12A preventSwipeBack" style="display: none;">
    <div class="nvBusinessInfoEachCon12B">
      <div class="ShareWindowCon2B">
        <div id="businessInfoConForDisplayBtnExit" class="nvBusinessInfoEachCon12C topRightExitButtonOnFullScreenWindow">
          <img height="20px" src="${iconBackStep}" alt="" />
        </div>
      </div>
    </div>

    ${this._generateInfo(data)}
  </div>
</div>
`;
  }

  // Start GEnerating Business Info
  _generateInfo(businessData) {
    const placeHtml = this._visualizerPopulateBusinessInfoPortion(
      "Lugar",
      this._visualizerPopulateBusinessInfoPlace(businessData.place)
    );

    const contactHtml = this._visualizerPopulateBusinessInfoPortion(
      "Contacto",
      this._visualizerPopulateBusinessInfoContact(businessData.contacts)
    );

    const aboutHtml = this._visualizerPopulateBusinessInfoPortion(
      "Acerca de nosotros",
      this._visualizerPopulateBusinessInfoAbout(businessData.about)
    );
    const finalPortionsHtml = placeHtml + contactHtml + aboutHtml;

    return this._visualizerPopulateBusinessInfoMain(finalPortionsHtml);
  }
  _visualizerPopulateBusinessInfoMain(html) {
    return `
    <div class="BusinessInfoCon3">${html}</div>
    `;
  }
  _visualizerPopulateBusinessInfoPortion(title, html) {
    return ` 
  <div id="BusinessInfoPortionCon1" class="BusinessInfoPortionCon1">
    <div class="BusinessInfoPortionHeaderText">
      ${title}
      </div>
    ${html}
  </div>
    `;
  }
  _visualizerPopulateBusinessInfoPlace(data) {
    return `
  <div class="BusinessInfoPortionLinkCon1">
    <img height="10px" src="${iconBlackLocation}" alt="" />
    <a class="BusinessInfoPortionLinkText" 
      href="${data.locationUrl}" 
      target="_blank" 
      rel="noopener noreferrer">
      ${GENRALHELPERS._getDisplayLocationName(data)}
    </a>
  </div>

  <div class="BusinessInfoLocationCon2">
    <div class="BusinessInfoLocationHeaderText">Descripción</div>
    <div class="BusinessInfoLocationCon3">
      <div class="BusinessInfoLocationDescriptionText">${data.description}</div>
    </div>
  </div>
    `;
  }
  _visualizerPopulateBusinessInfoContact(data) {
    let contactWays = ""; // Initialize as an empty string to avoid 'undefined'


    if (data.call) {
      contactWays += `
      <a href="tel:+52${data.call.contact}">
      <div id="BusinessInfoPortionLinkCon1" class="BusinessInfoPortionLinkCon1">
        <img height="10px" src="${iconBlackCall}" alt="" />
        <div class="BusinessInfoPortionLinkText">${data.call.contact}</div>
      </div>
      </a>`;
    }
    if (data.whatsApp) {
      contactWays += `
      <div id="DisplayBusinessEachInfoPortionWahtsApp" class="BusinessInfoPortionLinkCon1">
        <img height="10px" src="${iconBlackWhatsApp}" alt="" />
        <div class="BusinessInfoPortionLinkText">${data.whatsApp.contact}</div>
      </div>`;
    }
    if (data.email) {
      contactWays += `
      <div data-email="${data.email.contact}" id="DsiplayBusinessEachInfoPortionEmail" class="BusinessInfoPortionLinkCon1">
        <img height="10px" src="${iconBlackEmail}" alt="" />
        <div class="BusinessInfoPortionLinkText">${data.email.contact}</div>
      </div>`;
    }
    if (data.website) {
      contactWays += `
      <a href="${data.website.contact}" target="_blank" rel="noopener noreferrer">
      <div id="BusinessInfoPortionLinkCon1" class="BusinessInfoPortionLinkCon1">
        <img height="10px" src="${iconBlackWebsite}" alt="" />
        <div class="BusinessInfoPortionLinkText">${data.website.contact}</div>
      </div>
      </a>`;
    }

    return `<div class="BusinessInfoContactCon1">${contactWays}</div>`;
  }
  _visualizerPopulateBusinessInfoAbout(about) {
    return `
  <div id="BusinessInfoAboutCon1" class="BusinessInfoAboutCon1">
    <div class="BusinessInfoAboutText">
      ${about}
    </div>
  </div>
    `;
  }
}

export default new GenerateHtml();
